// Shared by the React <Seo> component and the build-time prerender plugin (craco.config.js). Keep import-free.
export function buildSeo(path, info, origin, content) {
  const page = content.pages[path];
  const company = info.company_name || "";
  const title = company ? `${page.title} | ${company}` : page.title;
  const url = origin + (path === "/" ? "/" : path);
  const image = origin + "/og-image.jpg";
  const meta = [
    ["name", "description", page.description], ["name", "robots", "index, follow, max-image-preview:large"],
    ["property", "og:type", "website"], ["property", "og:site_name", company || page.title], ["property", "og:title", title],
    ["property", "og:description", page.description], ["property", "og:url", url], ["property", "og:image", image],
    ["property", "og:image:width", "1200"], ["property", "og:image:height", "630"], ["property", "og:locale", "en_US"],
    ["name", "twitter:card", "summary_large_image"], ["name", "twitter:title", title], ["name", "twitter:description", page.description], ["name", "twitter:image", image],
  ];
  const business = {
    "@context": "https://schema.org", "@type": "ProfessionalService", "@id": origin + "/#business", name: company || page.title, url: origin + "/",
    image, description: content.pages["/"].description, areaServed: { "@type": "Country", name: "United States" },
    serviceType: ["Feasibility study", "Site feasibility study", "Franchise feasibility study", "SBA loan feasibility study"],
  };
  if (info.has_logo) business.logo = origin + "/api/public/logo";
  if (info.tiers?.length) {
    business.hasOfferCatalog = { "@type": "OfferCatalog", name: "Feasibility studies", itemListElement: info.tiers.map((t) => ({
      "@type": "Offer", name: `${t.label} feasibility study`, price: String(t.price), priceCurrency: info.currency || "USD",
      itemOffered: { "@type": "Service", name: `${t.label} feasibility study` },
    })) };
  }
  const faq = (pairs) => ({ "@context": "https://schema.org", "@type": "FAQPage", mainEntity: pairs.map(([q, a]) => ({ "@type": "Question", name: q, acceptedAnswer: { "@type": "Answer", text: a } })) });
  const jsonLd = [business];
  if (path === "/") {
    jsonLd.push({ "@context": "https://schema.org", "@type": "WebSite", name: company || page.title, url: origin + "/" }, faq([...content.faq, ...content.pricingFaq]));
  } else {
    jsonLd.push(
      { "@context": "https://schema.org", "@type": "Service", name: page.title, serviceType: "Loan feasibility study", description: page.description, provider: { "@id": origin + "/#business" }, areaServed: { "@type": "Country", name: "United States" }, url },
      { "@context": "https://schema.org", "@type": "BreadcrumbList", itemListElement: [{ "@type": "ListItem", position: 1, name: "Home", item: origin + "/" }, { "@type": "ListItem", position: 2, name: page.title, item: url }] },
    );
  }
  return { title, url, meta, jsonLd };
}
